import { SxProps, Theme } from "@mui/material";
import TableCell from "@mui/material/TableCell";

type CustomTableCellProps = {
  align?: "left" | "center" | "right" | "justify" | "inherit" | undefined;
  colSpan?: number;
  children?: React.ReactNode;
  sx?: SxProps<Theme>;
};
const CustomOwnerTableCell = (props: CustomTableCellProps) => {
  return (
    <TableCell
      align={props.align}
      colSpan={props.colSpan}
      sx={{
        color: "#333333",
        borderBottom: "1px solid #C9D0DC",
        ...props.sx,
      }}
    >
      {props.children}
    </TableCell>
  );
};

export default CustomOwnerTableCell;
